import React from 'react';
import * as Select from '@radix-ui/react-select';
import { User, Check } from 'lucide-react';
import { Membership } from 'api-client';

interface AssigneeSelectProps {
  assignees: Membership[];
  onAssign: (assigneeId: string) => void;
  currentAssigneeId?: string;
}

export const AssigneeSelect: React.FC<AssigneeSelectProps> = ({
  assignees,
  onAssign,
  currentAssigneeId,
}) => {
  return (
    <Select.Root value={currentAssigneeId} onValueChange={onAssign}>
      <Select.Trigger
        className="flex items-center space-x-2 text-sm text-gray-400 hover:text-white transition-colors outline-none"
        aria-label="Assign to"
      >
        <div className="h-6 w-6 rounded-full bg-gray-800 flex items-center justify-center">
          <User className="h-4 w-4 text-gray-400" />
        </div>
        <Select.Value placeholder="Assign to" />
      </Select.Trigger>

      <Select.Portal>
        <Select.Content
          className="min-w-[220px] bg-[#1A1F2E] rounded-lg p-1 shadow-xl border border-gray-800"
          position="popper"
          sideOffset={5}
          align="start"
        >
          <Select.ScrollUpButton />
          <Select.Viewport>
            <Select.Group>
              <Select.Label className="px-3 py-2 text-xs text-gray-500 font-medium">
                Assign to
              </Select.Label>
              {assignees.map((assignee) => (
                <Select.Item
                  key={assignee.id}
                  value={assignee.id?.toString()}
                  className="flex items-center px-3 py-2 text-sm text-gray-300 hover:bg-gray-800/50 rounded-md cursor-pointer outline-none data-[highlighted]:bg-gray-800/50"
                >
                  <Select.ItemIndicator className="absolute left-2">
                    <Check className="h-4 w-4" />
                  </Select.ItemIndicator>
                  <div className="flex items-center space-x-3">
                    <div className="h-8 w-8 rounded-full bg-gray-800 flex items-center justify-center">
                      {assignee.avatarUrl ? (
                        <img
                          src={assignee.avatarUrl}
                          alt={assignee.displayName}
                          className="h-8 w-8 rounded-full"
                        />
                      ) : (
                        <User className="h-5 w-5 text-gray-400" />
                      )}
                    </div>
                    <div>
                      <div className="font-medium">{assignee.displayName}</div>
                      <div className="text-xs text-gray-500">{assignee.role}</div>
                    </div>
                  </div>
                </Select.Item>
              ))}
            </Select.Group>
          </Select.Viewport>
          <Select.ScrollDownButton />
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  );
};